export default function (grade) {
  if (!grade) return null;
  if (grade.short === 'K') return grade.long;
  return `${grade.short} Grade`;
}



// WEBPACK FOOTER //
// ./app/features/shared/services/getDisplayableShortGrade.js